import { MenuItem, Typography, FormControl, Select, createTheme, ThemeProvider } from '@mui/material';
import { useEffect, useState, useRef } from 'react'; 
import isNullOrUndefined from '../functions/isNullOrUndefined'; 
 
const theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#E6EDF1",
          },
          "&.Mui-selected:focus": {
            backgroundColor: "#E6EDF1",
          },
          "&.MuiMenuItem-root": {
            borderBottom: "1px solid #E6EDF1",
            fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
          },
          // '&.Mui-selected:hover': {
          // backgroundColor: 'black',
          // },
          // '&:hover': {
          // backgroundColor: 'lightblue',
          // },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.MuiInputBase-root": {
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "24px",
            backgroundColor: "white",
            height: "40px",
            fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          "&.MuiPaper-root": {
            // overflow: "hidden",
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          "&.MuiList-root": {
            paddingTop: 0,
            maxHeight: '30vh', // Set the desired height for the list
            overflowY: 'auto', // Enable vertical scrolling for the list,
          },
        },
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          "&.MuiListSubheader-root": {
            height: "32px",
            paddingLeft: 0,
            paddingRight: 0,
            borderColor: "#E6EDF1",
          },
          "&.MuiListSubheader-root:focus": {
            borderColor: "#E6EDF1",
          },
        },
      },
    },
  },
});
 
const PageDropdownReduxWithIdObj = ({ tag, list, obj, setObj, width, font = "14px", showError, alignContent='center', topAlignTypography = false}) =>{
  // initialize ref
  const ref = useRef();
  // set width if not given as prop
  if (width == null) {
    width = "12rem";
  }
  // set font size if given as prop, else use default
  let style = {};
  if (font != null) {
    style["fontSize"] = font;
  }
  // event handler to set value on dropdown change
  const onDropdownChange = (e) => {
    setObj(e.target.value);
  }; 

  
  let contentCss = "d-flex justify-content-center width-fit-content align-items-center gap-3"
  if ( alignContent === 'center') {
    contentCss = "d-flex justify-content-center width-fit-content align-items-center gap-3"
  }
  else if (alignContent === 'left') {
    contentCss = "d-flex justify-content-left width-fit-content align-items-left gap-3"
  }
  else if (alignContent === 'right'){
    contentCss = "d-flex justify-content-right width-fit-content align-items-right gap-3"
  }

  // handle showing error and setting focus
  const [error, setError] = useState(); 
  useEffect(() => {
      if (showError && showError == true) { 
          // set show error
          setError(error => error = true); 
          // focus on error element 
          ref.current.focus();
      }
      else {
          setError(error => error = false); 
      }
  }, [showError]); 

  // useEffect to run on initial render
  useEffect(() => {
    if (!isNullOrUndefined(obj)) { 
      // check if object is equal to any in list
      for (let i = 0; i < list.length; i++) { 
        // check id and label 
        if (list[i].id === obj.id && list[i].label === obj.label) {
          // assign object with same reference so it shows as selected
          setObj(list[i]); 
          break; 
        }
      }
    } 
  }, [list]); 

  return (
    <div className={contentCss}>
        <ThemeProvider theme={theme}>
          <div className={topAlignTypography ? 'd-flex flex-column w-100': 'd-flex justify-content-center width-fit-content align-items-center gap-3'}>
              {/* material ui dropdown component */}
              <Typography fontSize={font} className={topAlignTypography ? "lh-24":"align-self-center lh-24"}>
                  {tag}
              </Typography>
              <FormControl fullWidth size='small' sx={{ minWidth: width, maxWidth: width }}>
                  <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={obj}
                      style={style}                 
                      onChange={(e)=>onDropdownChange(e)}
                      error={error}
                      inputRef={ref}
                  >
                      {list.map( el =>    
                          <MenuItem style={style} id={el['id']} value={el} >{el['label']}</MenuItem>
                      )}
                  </Select>
              </FormControl>
          </div>
        </ThemeProvider>
    </div>
  );
}
 
export default PageDropdownReduxWithIdObj;